// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewInfoLabel__wrapper___CY1pV","container":"ViewInfoLabel__container___CeCI2"};